export const PAYMENT_ERRORS = ['PAYMENT_METHOD_CARD_ERROR']
export const CODE_ERRORS = {
    CODE_422: "status 422"
}
export const AUTO_LOGIN_ERRORS = ['EMAIL_VALIDATED','INVALID_TOKEN']
